/**
 * @generated SignedSource<<5fc0d1808d98efa33f0029f0c2c52ca3>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type globalCheckerContent$data = {
  readonly " $fragmentSpreads": FragmentRefs<"articlePaywallCheckerContent">;
  readonly " $fragmentType": "globalCheckerContent";
};
export type globalCheckerContent$key = {
  readonly " $data"?: globalCheckerContent$data;
  readonly " $fragmentSpreads": FragmentRefs<"globalCheckerContent">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "globalCheckerContent",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "articlePaywallCheckerContent"
    }
  ],
  "type": "Content",
  "abstractKey": "__isContent"
};

(node as any).hash = "1551b7d7f56450c78104282c5c765e86";

export default node;
